import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form, Segment, Input } from 'semantic-ui-react';
import {
  getContactId,
  getCreationDate,
  getName,
  getSiteId,
} from '../reducers/form';
import SiteSelector from './SiteSelector';
import ContactSelector from './ContactSelector';
import { updateData } from '../actions/form';

export class General extends React.Component {
  render() {
    const {
      name,
      creationDate,
      customerId,
      onChangeName,
      readOnly,
    } = this.props;

    return (
      <Segment>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Nom du chantier</label>
            <Input value={name} onChange={onChangeName} readOnly={readOnly} />
          </Form.Field>
          <Form.Field>
            <label>Date de création</label>
            <Input value={creationDate} disabled />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <SiteSelector customerId={customerId} readOnly={readOnly} />
          </Form.Field>
          <Form.Field>
            <ContactSelector customerId={customerId} readOnly={readOnly} />
          </Form.Field>
        </Form.Group>
      </Segment>
    );
  }
}

General.propTypes = {
  name: PropTypes.string,
  creationDate: PropTypes.string,
  siteId: PropTypes.number,
  contactId: PropTypes.number,
  customerId: PropTypes.number.isRequired,
  onChangeName: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  name: getName(state),
  creationDate: getCreationDate(state),
  siteId: getSiteId(state),
  contactId: getContactId(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChangeName: (_, payload) => dispatch(updateData('name', payload.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(General);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/General.js